import { useFetch } from "../../../hooks/api";
import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPProductCategories = () => {
  const { dspAdvertiser } = useDSPSellerInfo();

  const { data, isLoading } = useFetch(
    ["dspProductCategories", dspAdvertiser?.id],
    "/api/dsp/product_categories",
    { dsp_seller_info_id: dspAdvertiser?.id },
    {
      select: (res) => {
        return JSON.parse(res.data.response)?.categories ?? [];
      },
      default: [],
      staleTime: 60 * 5 * 1000,
    },
  );

  return { data, isLoading };
};
